export default __webpack_public_path__ + "static/media/img-0254-afghanistan-half-face.3e6cbe5a.png";